import styled, { keyframes, css } from 'styled-components';
import { Card, Button,Col, Steps, Typography, Collapse,Upload, Carousel, Image } from 'antd';
import {MySegmented} from "../../components";
const isMobile = window.innerWidth < 768;

const { Paragraph } = Typography;
const { Step } = Steps;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
`;

export const ButtonContainer = styled.div`
  background-color: white;
  width: ${isMobile ? '38px' : '48px'};
  height: ${isMobile ? '38px' : '48px'};
  border-radius: 50%;
  border: 2px solid rgba(229, 233, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 189, 244, 1);
    & svg {
      color: #fff;
    }
  }
`;

export const PlayButtonContainer = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    & svg {
      color: #fff;
    }
  }
`;


export const PageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LessonPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 20px;

  .ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
    inset-inline-start: 10px !important;
  }

  .ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
    background-color: rgba(217, 219, 225, 1);
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    width: 2px !important;
    border: 2px dashed #fff !important;
    inset-inline-start: 10px !important;
  }
`;

export const ThemeMobileButton = styled.button`
  background-color: rgba(231, 250, 255, 1);
  color: rgba(0, 141, 210, 1);
  border: none;
  padding: 10px 20px;
  border-radius: 40px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  width: 108px;
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ScrollableCol = styled(Col)`
  overflow-x: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius: 3px;
    
  }
`;

export const LessonContainer = styled(Card)`
  width: 80%;
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;

`;

export const VideoWrapper = styled.div`
  margin: 20px 0;
  iframe {
    width: 100%;
    height: 400px;
    border-radius: 10px;
  }
`;

export const LessonSteps = styled(Steps)`
  margin-top: 20px;
  width: 100%;

  .ant-steps-item-container{
    height: 68px !important;
    display: flex;
    align-items: center;
  }

  .ant-steps-item-tail::after {
  display: none !important;
  }

   &.ant-steps-horizontal {
        flex-direction: row !important;
    }

`;

export const GoalText = styled(Paragraph)`
  font-weight: bold;
  margin-bottom: 10px;
`;

export const ContentText = styled(Paragraph)`
  margin-bottom: 20px;
`;

export const StyledButton = styled.button<{ animate: boolean }>`
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  border-radius: 4px;
  transition: opacity 0.3s ease;

  ${({ animate }) =>
    animate &&
    css`
      animation: ${fadeOut} 0.3s forwards;
    `}
`;

export const StyledStep = styled(Step)`

  .ant-steps-item-icon {
    border: none;
  }
`;

export const StepIconWrapper = styled.div<{ completed: boolean }>`
  width: 26px;
  height: 26px;
  background-color: ${({ completed }) => (completed ? '#52c41a' : 'rgba(150, 155, 171, 1)')};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: ${({ completed }) => (completed ? "'✓'" : "'✕'")};
    color: #fff;
    font-size: 16px;
  }

  
`;

export const StyledCarousel = styled(Carousel)`
    .slick-next {
    top: 40% !important;
    background: rgba(150, 155, 171, 1) !important;
    right: 35px !important;
    width: 60px !important;
    height: 60px !important;
    opacity: 0.90 !important;
    border-radius: 12px;
    }

    .slick-prev {
    top: 40% !important;
    background: rgba(150, 155, 171, 1) !important;
    opacity: 0.90 !important;
    width: 60px !important;
    height: 60px !important;
    border-radius: 12px;
    }

    .slick-next::after {
    top: 40% !important;
    left: 35% !important;
    }

    .slick-prev::after {
    top: 40% !important;
    left: 40% !important;
    }
`;

export const CustomPanel = styled(Collapse)`
    .ant-collapse>.ant-collapse-item >.ant-collapse-header .ant-collapse-arrow {
    display: none;
    }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 50px;
  padding: 5px 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const SearchIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(231, 250, 255, 1);
  
  svg {
    font-size: 24px;
    color: rgba(0, 141, 210, 1); 
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  width: ${isMobile ? '40%' : 'auto'};
  border: none;
  outline: none;
  padding: 10px;
  font-size: 18px;
  line-height: 24px;
  background-color: transparent;
`;

export const SearchButton = styled.button`
  background-color: #00bfff;
  color: white;
  border: none;
  padding: ${isMobile ? '0' : '10px 20px'};
  border-radius: ${isMobile ? '50%' : '40px'};
  font-size: ${isMobile ? '0' : '18px'};
  cursor: pointer;
  width: ${isMobile ? '50px' : 'auto'};
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #00a3e0;
  }
`;

export const StyledSegmented = styled(MySegmented)`
  .ant-segmented-item {
    margin-right: 8px; 
    color: rgba(19, 15, 38, 1);
    height: 40px;
    background-color: rgba(244, 245, 247, 1);
  }

  .ant-segmented-item-selected {
    background-color: rgba(231, 250, 255, 1);
  }

`;

export const CustomCollapse = styled(Collapse)`
  margin-bottom: 16px;
  background-color: white; /* Default background color */

  &.active {
    background-color: rgba(252, 248, 241, 1);
  }

  .ant-collapse-content {
    border-top: none !important;
  }

  .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
    display: none !important;
  }

  .ant-collapse-content.ant-collapse-content-active {
    background: rgba(252, 248, 241, 1);
  }

  .ant-collapse-item.ant-collapse-item-active {
  background: rgba(252, 248, 241, 1);
  border-radius: 8px !important;
    .ant-typography {
        color: rgba(205, 97, 21, 1) !important;
    }
  }

  .ant-collapse-item {
  background: #fff;
  border-radius: 8px !important;
  }
`;

export const StyledUpload = styled(Upload)`
  width: 100%;
  
  .ant-upload {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;

export const ThemeCollapse = styled(Collapse)`
  margin-bottom: 16px;
  background-color: white;
  min-height: 56px;

  &.active {
    background-color: rgba(231, 250, 255, 1);
  }


  .ant-collapse-item.ant-collapse-item-active {
  background: rgba(231, 250, 255, 1);
  border-radius: 8px !important;
    .ant-typography {
        color: rgba(0, 141, 210, 1) !important;
    }
  }

  .ant-collapse-item {
  background: #fff;
  border-radius: 8px !important;
  }

  .ant-collapse-header {
  flex-direction: row-reverse;
  }
  
  .ant-collapse-header-text{
  max-width: 190px;
  }
`;


export const ThemeButton = styled(Button)`
  
  .ant-btn-default.ant-btn-color-default.ant-btn-variant-outlined {
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
      color: none !important;
      border-none: inherit !important;
    }
  }
  
  .ant-btn-color-default {
    box-shadow: none !important;
  }
`;

export const StyledImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .ant-image {
    height: 100%;
    width: 100%;
  }

  .ant-image-img {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const StyledCard = styled(Card)`

  .ant-card-body {
    padding: ${isMobile ? '12px' : '24px'} !important;
  }

`;
